import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { canAccessInternalPath, normalizeInternalRole } from "@/lib/roles";
import { getAppPageHref, type AppPageDestination } from "./app-pages";

export function AppPageLink({ destination, userRole, userEmail, isLive }: {
	destination: AppPageDestination;
	userRole: string | undefined;
	userEmail?: string | null;
	isLive: boolean;
}) {
	const role = normalizeInternalRole(userRole);
	if (!isLive || !role || (destination.roles && !destination.roles.includes(role))) return null;
	const href = getAppPageHref(destination);
	if (destination.app === "internal" && !canAccessInternalPath(userRole, new URL(href).pathname, userEmail)) return null;
	return (
		<div className="space-y-2">
			<Button asChild variant="outline" className="h-auto min-h-11 max-w-full whitespace-normal text-left text-xs">
				<a href={href} target="_blank" rel="noopener noreferrer">
					{destination.label}<ExternalLink className="size-3.5" aria-hidden="true" />
					<span className="sr-only"> (opens in a new tab)</span>
				</a>
			</Button>
			{destination.hint && <p className="text-xs leading-5 text-muted-foreground">{destination.hint}</p>}
		</div>
	);
}
